import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	DateTimeField,
	ModuleSearchField,
	SimpleTextField,
	TagsSelectField,
	useSettings,
	useUserData
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function DemsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			<Grid size={12}>
				{/* TITLE */}
				<SimpleTextField
					name="dems_title"
					label={t('DETAILS_DEMS_FIELD_TITLE')}
					value={props.model.dems_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DATE and TIME */}
				<DateTimeField
					name="dems_date"
					label={t('DETAILS_DEMS_FIELD_DATE')}
					value={props.model.dems_date}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ORIGIN MARKETING ACTION */}
				<ModuleSearchField
					name="dems_maac_uid"
					label={t('DETAILS_DEMS_FIELD_MARKETINGACTION')}
					module="marketingactions"
					uid={props.model.dems_maac_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="dems_user_assigned_uid"
					label={t('DETAILS_DEMS_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.dems_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED GROUP */}
				<ModuleSearchField
					name="dems_grps_uid"
					label={t('DETAILS_DEMS_FIELD_ASSIGNED_GROUP')}
					module="groups"
					uid={props.model.dems_grps_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="dems_warning_desc"
					label={t('DETAILS_DEMS_FIELD_WARNING')}
					value={props.model.dems_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="dems_blocked_desc"
					label={t('DETAILS_DEMS_FIELD_BLOCKED')}
					value={props.model.dems_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="dems_tags"
					label={t('DETAILS_DEMS_FIELD_TAGS')}
					value={props.model.dems_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
